import React, { useState } from "react";
import "../../index.css";
import "../../App.css";
import { Slider, Typography } from "antd";

import PainLevel1 from "../../graphics/painLevels/1.svg";
import PainLevel2 from "../../graphics/painLevels/2.svg";
import PainLevel3 from "../../graphics/painLevels/3.svg";
import PainLevel4 from "../../graphics/painLevels/4.svg";
import PainLevel5 from "../../graphics/painLevels/5.svg";
import PainLevel6 from "../../graphics/painLevels/6.svg";
import PainLevel7 from "../../graphics/painLevels/7.svg";
import PainLevel8 from "../../graphics/painLevels/8.svg";
import PainLevel9 from "../../graphics/painLevels/9.svg";
import PainLevel10 from "../../graphics/painLevels/10.svg";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "../../redux-toolkit/store/store";
import { updateUserPainProfileRating } from "../../redux-toolkit/slices/orderCreamSlice";
const RatePainOrderCreamSelector = () => {
  const painRating = useSelector(
    (state: RootState) => state.orderCream.painProfile.painRating
  );
  const dispatch = useDispatch();
  const painLevelMarks = {
    1: (
      <img
        src={PainLevel1}
        alt="Pain Free"
        style={{ width: "24px", height: "24px" }}
      />
    ),
    2: (
      <img
        src={PainLevel2}
        alt="Barely noticeable"
        style={{ width: "24px", height: "24px" }}
      />
    ),
    3: (
      <img
        src={PainLevel3}
        alt="Slight ache"
        style={{ width: "24px", height: "24px" }}
      />
    ),
    4: (
      <img
        src={PainLevel4}
        alt="Noticable discomfort"
        style={{ width: "24px", height: "24px" }}
      />
    ),
    5: (
      <img
        src={PainLevel5}
        alt="Moderately uncomfortable"
        style={{ width: "24px", height: "24px" }}
      />
    ),
    6: (
      <img
        src={PainLevel6}
        alt="Significant discomfort"
        style={{ width: "24px", height: "24px" }}
      />
    ),
    7: (
      <img
        src={PainLevel7}
        alt="Very uncomfortable"
        style={{ width: "24px", height: "24px" }}
      />
    ),
    8: (
      <img
        src={PainLevel8}
        alt="Hard to function"
        style={{ width: "24px", height: "24px" }}
      />
    ),
    9: (
      <img
        src={PainLevel9}
        alt="Almost unbearable"
        style={{ width: "24px", height: "24px" }}
      />
    ),
    10: (
      <img
        src={PainLevel10}
        alt="Severe Pain, I need to go to the ER"
        style={{ width: "24px", height: "24px" }}
      />
    ),
  };

  return (
    <div className="flex flex-col gap-4 w-full">
      <Typography className="h6 text-theme-text-secondary">
        <strong>On a scale of 1 to 10, how would you rate your pain right now? *</strong>
      </Typography>
      <Slider
        marks={painLevelMarks}
        min={1}
        max={10}
        defaultValue={3}
        onChange={(value: number) => {
          dispatch(updateUserPainProfileRating(value));
        }}
        value={painRating}
        styles={{
          track: {
            background: "transparent",
          },
          tracks: {
            background: `#0F3B48`,
          },
        }}
      />
    </div>
  );
};

export default RatePainOrderCreamSelector;
